<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ project.title }}</h3>
    </route-header>
    <div class="row mt-3">
      <div class="col-12 col-sm-6 col-lg-4 mb-3">
        <bs-card class="card-info text-center">
          <h4 class="my-3">{{ find(customers, 'id', project.customer_id, 'name') }}</h4>
          <ul class="list-group list-group-flush">
            <li class="list-group-item text-left border-top">
              <small class="text-uppercase">{{ $t('labels.description') }}</small><br>
              <span>{{ project.description }}</span>
            </li>
          </ul>
          <template v-slot:footer>
            <div class="m-3">
              <bs-button class="btn-sm btn-info" @click="update(project)">{{ $t('labels.update') }}</bs-button>
            </div>
          </template>
        </bs-card>
      </div>
      <div class="col-8">
        <project-workers :project="this.id" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <project-timers :project="this.id" />
      </div>
    </div>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="{ error }">
          <tuxedo-input :name="'title'" :label="$t('labels.title')" v-model="resource.title" :error="error" />
          <tuxedo-select :name="'manager_id'" :label="$tc('labels.manager', 1)" v-model="resource.manager_id" :options="users" :insistLabel="'name'" :insistReturn="'id'" :error="error" />
          <tuxedo-select :name="'customer_id'" :label="$tc('labels.customer', 1)" v-model="resource.customer_id" :options="customers" :insistLabel="'name'" :insistReturn="'id'" :error="error" />
          <text-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="error" />
        </template>
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../mixins/resourceControl'

export default {
  name: 'Project',
  props: ['id'],
  mixins: [resourceControl],
  data () {
    return {
      view: 'single',
      resource: {
        title: '',
        manager_id: null,
        customer_id: null,
        description: null
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      project: state => state.project.data,
      users: state => state.usersStore,
      customers: state => state.customersStore
    }),
    apiTarget () { return ['projects', this.id] }
  },
  methods: {
  }
}
</script>
